/* NgRx Selectors */

import { createFeatureSelector, createSelector } from "@ngrx/store";
import { FeatureKeys } from "../app.reducer";
import { DeliveryChecklistState, IChecklistSummaryState,IArchivedChecklistSummaryState } from "./delivery-checklist.reducer";
import * as fromReducer from '../delivery-checklist/delivery-checklist.reducer'; 
import { IAsyncData, IDigitalChecklist, IVehicle } from "@signal/asp-data-commons";
import { vehicleFormToSummaryProjector } from "./delivery-checklist.adapter";

/* To select the delivery checklist feature state from the app state */
export const selectDigitalChecklistFeature = createFeatureSelector<DeliveryChecklistState>(FeatureKeys.DELIVERY_CHECKLIST);


export const stateDetails = createSelector(
  selectDigitalChecklistFeature,
  (state: fromReducer.DeliveryChecklistState) => state
);

/* To select delivery checklist summary */
export const selectChecklistSummaryState = createSelector(
  selectDigitalChecklistFeature,
    (state: DeliveryChecklistState) => state.checklistSummary
  );

export const selectChecklistSummary = createSelector(
    selectChecklistSummaryState,
    (state: IChecklistSummaryState) => state.data
  );  
  export const selectChecklistSummaryLoading = createSelector(
    selectChecklistSummaryState,
    (state: IChecklistSummaryState) => state.loading
  );

  export const  selectChecklistSummaryCount = createSelector(
    selectChecklistSummaryState,
    (state: IChecklistSummaryState) => state.allChecklistCount
  );

  export const  selectSummaryTotalCount = createSelector(
    selectChecklistSummaryState,
    (state: IChecklistSummaryState) => state.totalCount
  );

/* To select archived delivery checklists */
  export const selectArchivedChecklistsState = createSelector(
  selectDigitalChecklistFeature,
    (state: DeliveryChecklistState) => state.archivedChecklists
  );

  export const selectArchivedChecklists = createSelector(
    selectArchivedChecklistsState,
    (state: IArchivedChecklistSummaryState) => state.data
  );  
  export const selectArchivedChecklistsLoading = createSelector(
    selectArchivedChecklistsState,
    (state: IArchivedChecklistSummaryState) => state.loading
  );
  export const selectArchivedChecklistsCount = createSelector(
    selectArchivedChecklistsState,
    (state: IArchivedChecklistSummaryState) => state.archivedChecklistsCount
  );

  export const selectArchivedChecklistsTotalCount = createSelector(
    selectArchivedChecklistsState,
    (state: IArchivedChecklistSummaryState) => state.totalCount
  );

/* digital checklist flow*/

export const DigitalChecklistDetails = createSelector(
  selectDigitalChecklistFeature,
  (state: fromReducer.DeliveryChecklistState) => state.digitalChecklist
); 

export const selectCustomerDetails = createSelector(
  DigitalChecklistDetails,
  (digitalChecklist: fromReducer.IDigitalChecklistForm) => digitalChecklist.customer
); 

export const checklistRequest = createSelector(
  selectDigitalChecklistFeature,
  (state: fromReducer.DeliveryChecklistState) => state.checklistRequest
)

export const descriptionOfProductsOrServices = createSelector(
  DigitalChecklistDetails,
  (digitalChecklist: fromReducer.IDigitalChecklistForm) => digitalChecklist.descriptionOfProductsOrServices
); 

export const selectOnlineChecklist = createSelector(
  checklistRequest,
  (state: IAsyncData<IDigitalChecklist[]>) => state.data
);

export const selectAllChecklistLoading = createSelector(
  checklistRequest,
  (state: IAsyncData<IDigitalChecklist[]>) => state.loading
);

export const selectVehicleForm = createSelector(
  DigitalChecklistDetails,
  (digiChecklist: fromReducer.IDigitalChecklistForm) => digiChecklist.vehicle
);

export const selectDigiChecklistFooterSummaries = createSelector(
  selectVehicleForm,
  (vehicleForm: IVehicle) => vehicleFormToSummaryProjector(vehicleForm)
);

export const selectEditDetails = createSelector(
  selectDigitalChecklistFeature,
  (state: fromReducer.DeliveryChecklistState) => state.editDetails
)

export const selectChecklistForm = createSelector(
  DigitalChecklistDetails,
  (digiChecklist: fromReducer.IDigitalChecklistForm) => digiChecklist.checklistRequest
);

export const selectCustomerSignatureObject = createSelector(
  DigitalChecklistDetails,
  (digiChecklist: fromReducer.IDigitalChecklistForm) => ({...digiChecklist.customer, customerSignId: digiChecklist.customerSignId})
);

export const selectTechnicianSignatureObject = createSelector(
  DigitalChecklistDetails,
  (digiChecklist: fromReducer.IDigitalChecklistForm) => digiChecklist.deliveryConsultant
);